import React, { useState, useEffect, useCallback, useRef } from "react";
import Dropdown from "./Dropdown";
import RoundCard from "../../Components/RoundCard";
import FixturePopup from "../../popups/FixturePopup";
import { utcToLocalDate, utcToLocalTime } from "../../../utils/convertTime";
import axios from "axios";
import {
  fetchRoundToJoinData,
  updateLoadingStatus,
  updateMyRound,
} from "./roundToJoin.slice";
import { useSelector, useDispatch } from "react-redux";
import useToastMessage from "../../Utiles/Toaster";
import { baseURL } from "../../services/axiosConfig";
import { refreshTokenV2 } from "../../services/api";
import useWebSocket from "../../websoket/websocket";
import CompletedRound from "./CompletedRound";
import { useLocation, useNavigate } from "react-router";

// Circular Loader Component
const CircularLoader = () => (
  <div className="flex flex-col items-center justify-center py-8">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
    <div className="text-blue-500 font-medium">Rounds Loading...</div>
  </div>
);

// Small loader for pagination
const PaginationLoader = () => (
  <div className="flex flex-col justify-center items-center py-4 gap-2">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
    <p className="text-blue-500 block font-medium">Loading More Rounds...</p>
  </div>
);

export default function LeagueList({
  deviceType,
  viewFixtureHandler,
  myPickHandler,
  isOpen,
  setIsOpen,
  fixturesData,
  selectedSubNav,
  sportLeague,
  setSelectedGame,
  data,
  selectedGame,
  setSelectedRounds,
  selectedRounds,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { roundId } = state || {};

  const selectedRoundId = roundId;

  const socketRef = useWebSocket("/ws/joinpot/pot/");
  const dispatch = useDispatch();
  const { showToast, showErrorToast } = useToastMessage();
  const token = localStorage.getItem("access_token");

  const rounds = [
    { id: 1, label: "All Rounds", value: "" },
    { id: 2, label: "Round Joined", value: "true" },
    { id: 3, label: "Round Not Joined", value: "false" },
  ];

  const [visibleLeagues, setVisibleLeagues] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [highlightedRoundId, setHighlightedRoundId] = useState(null);

  const [tabStates, setTabStates] = useState({
    completed: {
      rounds: [],
      currentPage: 1,
      totalPages: 1,
      isLoadingMore: false,
      hasMorePages: false,
    },
    myRound: {
      rounds: [],
      isLoaded: false,
    },
    roundToJoin: {
      rounds: [],
      isLoaded: false,
    },
  });

  const observerRefs = useRef({ completed: null });
  const lastElementRefs = useRef({ completed: null });

  const myRound = useSelector((state) => state.roundToJoin.myRound);
  const roundToJoinPotData = useSelector(
    (state) => state.roundToJoin.roundToJoinPotData
  );

  // 🔑 Store refs for each round card in "Round to Join"
  const roundRefs = useRef({});

  const updateTabState = (tab, updates) => {
    setTabStates((prevStates) => ({
      ...prevStates,
      [tab]: {
        ...prevStates[tab],
        ...updates,
      },
    }));
  };

  const clearTabState = (tab) => {
    if (tab === "completed") {
      dispatch(updateMyRound([]));
      updateTabState("completed", {
        rounds: [],
        currentPage: 1,
        totalPages: 1,
        isLoadingMore: false,
        hasMorePages: false,
      });
    }
  };

  useEffect(() => {
    setSelectedRounds();
  }, [selectedSubNav]);

  const loadPage = async (pageNum, potStatus, selectedGame) => {
    dispatch(updateLoadingStatus(true));
    setIsLoading(true);
    try {
      let url = `${baseURL}/dashboard/rounds/${potStatus}/?page=1&limit=1000`;
      if (
        selectedGame?.sport?.id ||
        selectedGame?.league?.id ||
        selectedGame?.roundState?.value
      ) {
        const searchParams = new URLSearchParams();

        if (selectedGame?.sport?.id) {
          searchParams.append("game_id", selectedGame.sport.id);
        }
        if (selectedGame?.league?.id) {
          searchParams.append("league_id", selectedGame.league.id);
        }
        if (selectedGame?.roundState?.value) {
          searchParams.append("status", selectedGame.roundState.value);
        }

        url += `&${searchParams.toString()}`;
      }

      const headers = {};
      if (token && token !== "null" && token !== "undefined") {
        try { headers.Authorization = `Bearer ${JSON.parse(token)}`; } catch {}
      }
      const res = await axios.get(url, { headers });

      const { leagues, pots } = res.data.data;

      if (selectedSubNav === "Round To Join") {
        setVisibleLeagues(leagues);
        dispatch(fetchRoundToJoinData({ roundToJoinPot: leagues }));
        updateTabState("roundToJoin", { isLoaded: true });
      } else if (selectedSubNav === "myRound") {
        dispatch(updateLoadingStatus(false));
        dispatch(updateMyRound(pots));
        updateTabState("myRound", { isLoaded: true });
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      dispatch(updateLoadingStatus(false));
      console.error("Error loading page", error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadCompletedRounds = async (page = 1, isLoadingMore = false) => {
    if (!isLoadingMore) {
      setIsLoading(true);
    } else {
      updateTabState("completed", { isLoadingMore: true });
    }

    try {
      let url = `${baseURL}/dashboard/rounds/completed/?page=${page}&limit=20`;

      if (selectedRounds?.value) {
        const searchParams = new URLSearchParams();

        if (selectedRounds?.value) {
          let actualValue;
          if (selectedRounds.value === "true") {
            actualValue = true;
          } else if (selectedRounds.value === "false") {
            actualValue = false;
          }
          searchParams.append("joined", actualValue);
        }

        url += `&${searchParams.toString()}`;
      }

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      });

      const { pots, total_pages } = res?.data?.data;

      if (page === 1) {
        updateTabState("completed", {
          rounds: pots || [],
          currentPage: 1,
          totalPages: total_pages || 1,
          hasMorePages: total_pages > 1,
          isLoadingMore: false,
        });
        setIsLoading(false);
      } else {
        updateTabState("completed", {
          rounds: [...tabStates.completed.rounds, ...(pots || [])],
          currentPage: page,
          hasMorePages: page < total_pages,
          isLoadingMore: false,
        });
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      showErrorToast("Failed to load completed rounds");
      updateTabState("completed", { isLoadingMore: false });
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    // Check if the page is loaded from a refresh
    const handlePageLoad = () => {
      // Reset location state on refresh
      if (location.state) {
        navigate(location.pathname, { replace: true, state: null });
      }
    };

    window.addEventListener("load", handlePageLoad);

    return () => {
      window.removeEventListener("load", handlePageLoad);
    };
  }, [location]);


  const lastElementCallback = useCallback(
    (node) => {
      const currentTabState = tabStates.completed;
      if (currentTabState.isLoadingMore || selectedSubNav !== "compleated")
        return;

      if (observerRefs.current.completed) {
        observerRefs.current.completed.disconnect();
      }

      observerRefs.current.completed = new IntersectionObserver(
        (entries) => {
          if (
            entries[0].isIntersecting &&
            currentTabState.hasMorePages &&
            selectedSubNav === "compleated"
          ) {
            loadCompletedRounds(currentTabState.currentPage + 1, true);
          }
        },
        {
          threshold: 0.1,
          rootMargin: "100px",
        }
      );

      if (node) observerRefs.current.completed.observe(node);
    },
    [
      tabStates.completed.isLoadingMore,
      tabStates.completed.hasMorePages,
      tabStates.completed.currentPage,
      selectedSubNav,
    ]
  );

  const setLastElementRef = useCallback(
    (node) => {
      lastElementRefs.current.completed = node;
      lastElementCallback(node);
    },
    [lastElementCallback]
  );

  useEffect(() => {
    return () => {
      Object.values(observerRefs.current).forEach((observer) => {
        if (observer) observer.disconnect();
      });
    };
  }, []);

  useEffect(() => {
    Object.values(observerRefs.current).forEach((observer) => {
      if (observer) observer.disconnect();
    });

    const potStatus =
      selectedSubNav === "Round To Join" ? "new" : "active";

    if (selectedSubNav === "compleated") {
      clearTabState("completed");
      loadCompletedRounds(1, false);
    } else {
      clearTabState("completed");
      loadPage(1, potStatus, selectedGame);
    }
  }, [selectedSubNav, selectedGame, selectedRounds]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedSubNav]);

  // --- Robust scroll to selectedRoundId ---
  useEffect(() => {
    let scrollTimeout;
    let tries = 0;
    function tryScrollToRound() {
      if (
        selectedSubNav === "Round To Join" &&
        selectedRoundId &&
        roundRefs.current[selectedRoundId]
      ) {
        roundRefs.current[selectedRoundId].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        setHighlightedRoundId(selectedRoundId);
        // Remove highlight after 2 seconds
        scrollTimeout = setTimeout(() => {
          setHighlightedRoundId(null);
        }, 2000);
        return; // done!
      }
      // Else, keep trying with max timeout
      if (tries < 20) { // try for up to 2 seconds (20*100ms)
        tries++;
        setTimeout(tryScrollToRound, 100);
      }
    }
    tryScrollToRound();
    return () => {
      clearTimeout(scrollTimeout);
    };
  }, [selectedSubNav, roundToJoinPotData, selectedRoundId]);

  const sendTestMessage = () => {
    if (WebSocket.OPEN) {
      console.log("WebSocket is open");
    } else {
      console.log("WebSocket is not open");
    }
  };

  useEffect(() => {
    sendTestMessage();
  }, []);

  const renderContent = () => {
    if (selectedSubNav === "Round To Join") {
      return (
        <div className="relative">
          {deviceType !== "mobile" && (
            <div className="w-[40%] flex gap-4 absolute top-[-20px] right-0 ">
              <Dropdown
                data={sportLeague.sport}
                className="round-to-join-dropdown"
                setSelectedGame={setSelectedGame}
                name="sport"
              />
              <Dropdown
                data={sportLeague.league}
                className="round-to-join-dropdown"
                setSelectedGame={setSelectedGame}
                name="league"
              />
              <Dropdown
                data={data}
                className="round-to-join-dropdown"
                setSelectedGame={setSelectedGame}
                name="round"
              />
            </div>
          )}
          {isLoading ? (
            <CircularLoader />
          ) : !roundToJoinPotData?.length ? (
            <div className="flex justify-center w-full py-8">
              <div className="text-gray-400 text-center">
                No rounds available to Join
              </div>
            </div>
          ) : (
            roundToJoinPotData.map((ele, index) => {
              return (
                <div key={ele.id} className="mb-8">
                  <div className="mb-4">
                    {ele.logo ? (
                      <h3 className="text-md sm:text-xl font-semibold font-archivo flex items-center gap-3">
                        <img
                          src={ele.logo}
                          alt={ele.season_name}
                          className="h-16 w-16 sm:h-10 sm:w-10 md:h-24 md:w-24 object-contain"
                        />
                        {ele.season_name}
                      </h3>
                    ) : (
                      <h3 className="text-xl font-archivo font-bold">
                        Rounds To Join
                      </h3>
                    )}
                  </div>
                  <div
                    className="flex flex-wrap gap-4 sm:gap-6 scrollbar-hide pb-2 sm:pb-4"
                    style={{ WebkitOverflowScrolling: "touch" }}
                  >
                    {!ele?.pots?.length ? (
                      <div className="text-gray-400 text-center w-full py-8">
                        You haven't participated in any rounds yet.
                      </div>
                    ) : (
                      ele.pots.map((r) => {
                        const isHighlighted = highlightedRoundId === r.id;
                        return (
                          <div
                            key={r.id}
                            ref={(el) => (roundRefs.current[r.id] = el)}
                            className={`transition-all duration-300 ${isHighlighted
                              ? "ring-4 ring-blue-500 ring-opacity-75 rounded-lg shadow-lg transform scale-105"
                              : ""
                              }`}
                          >
                            <RoundCard
                              leagueId={ele.league_id}
                              round={r.id}
                              potInfo={r}
                              logo={r.season_logo}
                              league={r.season_name}
                              currency={r?.pot_currency}
                              year={r.season_year}
                              amount={r.pot_value}
                              netPotValue={r.net_pot_value}
                              filled={r.filled}
                              status={r.status}
                              timer={r.timer}
                              up={r.active_picks_count}
                              down={r.lost_picks_count}
                              color={r.season_card_color}
                              isMyRound
                              picks={r.pick_id}
                              pot_value_percentage={r?.pot_amount_percentage}
                              endTime={r.last_entry_time}
                              btn_color={r?.season_btn_color}
                              btn_text_color={r?.season_btn_text_color}
                              progress_color={r?.progress_bar_color}
                              cartType="roundToPlay"
                              viewFixtureHandler={viewFixtureHandler}
                              gameName={r?.game_name}
                              gameId={r?.game_id}
                            />
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
      );
    } else if (selectedSubNav === "myRound") {
      return (
        <>
          <h3 className="text-2xl font-semibold font-archivo mb-4">
            My Rounds
          </h3>

          <div className="flex flex-wrap gap-4 sm:gap-6">
            {isLoading ? (
              <div className="flex justify-center items-center w-full min-h-[200px]">
                <CircularLoader />
              </div>
            ) : myRound?.length > 0 ? (
              myRound?.map((r) => {
                return (
                  <RoundCard
                    key={r.id}
                    leagueId={r.league_id}
                    potInfo={r}
                    round={r.id}
                    logo={r.season_logo}
                    league={r.season_name}
                    currency={r?.pot_currency}
                    year={r.season_year}
                    amount={r.pot_value}
                    netPotValue={r.net_pot_value}
                    filled={r.filled}
                    status={r.status}
                    timer={r.timer}
                    up={r.active_picks_count}
                    down={r.lost_picks_count}
                    color={r.season_card_color}
                    isMyRound
                    picks={r.pick_id}
                    btn_color={r?.season_btn_color}
                    btn_text_color={r?.season_btn_text_color}
                    pot_value_percentage={r?.pot_amount_percentage}
                    endTime={r?.dead_line?.dead_line}
                    lastEntryTime={r.last_entry_time}
                    progress_color={r?.progress_bar_color}
                    cartType="myRound"
                    viewFixtureHandler={viewFixtureHandler}
                    gameName={r?.game_name}
                    gameId={r?.game_id}
                  />
                );
              })
            ) : (
              <div className="flex justify-center w-full">No Data found</div>
            )}
          </div>
        </>
      );
    } else if (selectedSubNav === "compleated") {
      const completedState = tabStates.completed;
      return (
        <>
         <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4">
            <div className="flex items-center justify-between gap-2 md:block">
              <h3 className="text-lg md:text-2xl font-semibold font-archivo mb-0 md:mb-4">
                Completed Rounds
              </h3>
              <div className="w-24 md:w-[60%] md:hidden">
                <Dropdown
                  data={rounds}
                  setSelectedGame={setSelectedGame}
                  setSelectedRounds={setSelectedRounds}
                  name="completedRound"
                />
              </div>
            </div>
            <div className="hidden md:flex gap-4" style={{ width: window.innerWidth >= 768 && window.innerWidth <= 1024 ? '150px' : '' }}>
              <Dropdown
                data={rounds}
                setSelectedGame={setSelectedGame}
                setSelectedRounds={setSelectedRounds}
                name="completedRound"
              />
            </div>
          </div>
          {isLoading ? (
            <CircularLoader />
          ) : (
            <div className="flex flex-wrap gap-4 sm:gap-6">
              {completedState.rounds?.length > 0 ? (
                completedState.rounds?.map((r, index) => {
                  const isLastElement =
                    index === completedState.rounds.length - 1;
                  return (
                    <div
                      key={r.id}
                      ref={isLastElement ? setLastElementRef : null}
                    >
                      <RoundCard
                        leagueId={r.league_id}
                        potInfo={r}
                        round={r.id}
                        logo={r.season_logo}
                        league={r.season_name}
                        currency={r?.pot_currency}
                        year={r.season_year}
                        amount={r.pot_value}
                        netPotValue={r.net_pot_value}
                        filled={r.filled}
                        status={r.status}
                        timer={r.timer}
                        up={r.active_picks_count}
                        down={r.lost_picks_count}
                        color={r.season_card_color}
                        isMyRound
                        picks={r.pick_id}
                        btn_color={r?.season_btn_color}
                        btn_text_color={r?.season_text_color}
                        pot_value_percentage={r?.pot_amount_percentage}
                        endTime={r?.dead_line.dead_line}
                        lastEntryTime={r.last_entry_time}
                        progress_color={r?.progress_bar_color}
                        cartType="completed"
                        viewFixtureHandler={viewFixtureHandler}
                        gameName={r?.game_name}
                        gameId={r?.game_id}
                      />
                      <CompletedRound pot={r} />
                    </div>
                  );
                })
              ) : (
                <div className="flex justify-center w-full">No Data found</div>
              )}
            </div>
          )}
          {completedState.isLoadingMore && <PaginationLoader />}

          {!completedState.hasMorePages && completedState.rounds.length > 0 && (
            <div className="text-center py-4 text-gray-400">
              No more rounds to load
            </div>
          )}
        </>
      );
    }
  };

  return (
    <div>
      {renderContent()}

      <FixturePopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        myPickHandler={myPickHandler}
        fixturesData={fixturesData}
      />
    </div>
  );
}
